import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Link, Redirect, useHistory } from 'react-router-dom';
import Select from 'react-select';
import moment from 'moment';
import { Modal, Accordion } from "react-bootstrap";
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import './date-range.css'
import { Pagination } from 'antd';
import swal from 'sweetalert';

import { useTheme } from "./theme-provider.js";
import { useAuthData } from "./auth-provider.js";
import { setCookie, getCookie } from '../common_component/cookie.js';
import StatusBadge from "../common_component/StatusBadge.js";
import PageError from "../common_component/PageError.js";
import { EcommerceOrderAssociatedInvoices } from "./view-ecommerce-order.js";
import PageLoader from "../common_component/PageLoader.js";

const statusTypeArray = ["ECOMMERCE_WAREHOUSE_PROCESSING_INIT", "ECOMMERCE_WAREHOUSE_PROCESSED", "ECOMMERCE_WAREHOUSE_PROCESSING_PARTIAL"]

function EcommerceWarehouseProcessingList() {
    const [state, setstate] = useState(2);
    const [statusType, setStatusType] = useState({ label: "All", value: "All" });
    const { theme, dropdownStyleDark } = useTheme()
    const history = useHistory()

    const [orgGstinList, setOrgGstinList] = useState([]);
    const daterange_picker_ref = useRef();
    const [startDate, setStartDate] = useState(moment.utc().subtract(6, "days").format("YYYY-MM-DD"))
    const [endDate, setEndDate] = useState(moment.utc().format("YYYY-MM-DD"))
    const [timezone_change, set_timezone_change] = useState("+00:00");
    const [ecommerceWarehouseProcessingList, setEcommerceWarehouseProcessingList] = useState([]);
    const [ecommerceWarehouseProcessingListApiState, setEcommerceWarehouseProcessingListApiState] = useState(false)
    const [totalListLength, setTotalListLength] = useState(0);

    const [itemDetailsModalShow, setItemDetailsModalShow] = useState(false)
    const [itemArrayIndex, setItemArrayIndex] = useState(null)

    const [createInvoiceModalShow, setCreateInvoiceModalShow] = useState(false)
    const [selectedWarehouseProcessingId, setSelectedWarehouseProcessingId] = useState(null)
    const [wizardState, setWizardState] = useState(0)
    const [selectedGstin, setSelectedGstin] = useState(null)
    const [invoiceList, setInvoiceList] = useState([])
    const [ecommerceInvoicePreviewApiState, setEcommerceInvoicePreviewApiState] = useState(false)
    const [ecommerceInvoiceSubmitApiState, setEcommerceInvoiceSubmitApiState] = useState(false)

    const [searchValue, setSearchValue] = useState("");
    const [current_page, setCurrent_page] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const presets = [
        { label: 'Today', start: new Date(), end: new Date() },
        { label: 'Last 7 days', start: new Date(new Date().setDate(new Date().getDate() - 7)), end: new Date() },
        { label: 'Last 30 days', start: new Date(new Date().setDate(new Date().getDate() - 30)), end: new Date() },
        { label: 'Last 90 days', start: new Date(new Date().setDate(new Date().getDate() - 90)), end: new Date() }
    ];

    var page_name = "ecommerce-warehouse-processing-list";

    const { user, read, write, visibility, organization_id } = useAuthData(page_name);

    let formatNumberOptions = {
        decimalPlaces: 2,
        removeTrailingZeros: true
    };

    async function getTimezoneInformation() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-organization-timezone-information`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation === "success") {
            if (body.data.length > 0) {
                if (body.data[0].timezone_value != "" && body.data[0].timezone_value != null) {
                    const timezone = body.data[0].timezone_value;
                    set_timezone_change(timezone);
                    setStartDate(moment().utcOffset(timezone).subtract(6, "days").format("YYYY-MM-DD"));
                    setEndDate(moment().utcOffset(timezone).format("YYYY-MM-DD"));
                }
                else {
                    setStartDate(moment.utc().subtract(6, "days").format("YYYY-MM-DD"));
                    setEndDate(moment.utc().format("YYYY-MM-DD"));
                }
            }
            else {
                setStartDate(moment.utc().subtract(6, "days").format("YYYY-MM-DD"));
                setEndDate(moment.utc().format("YYYY-MM-DD"));
            }
        }
        else {
            throw "timezone api error"
        }
    }

    async function getEcommerceWarehouseProcessingList(signal, sd, ed, page_number, size, search_val, st) {
        try {
            setEcommerceWarehouseProcessingListApiState(true)
            // setDealerCollectionList([]);
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get-ecommerce-warehouse-processing-list`, { signal, method: 'POST', body: JSON.stringify({ "email": user.email, "start_date": sd, "end_date": ed, "current_page": page_number - 1, "rows_per_page": size, "search_value": search_val, "status_type": st, "page_name": page_name, "flag": "collection_list", "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();
            if (body.operation !== "success") throw "get ecommerce order list api error"

            setEcommerceWarehouseProcessingList(body.data.list)
            setTotalListLength(body.data.count)
            setEcommerceWarehouseProcessingListApiState(false)
        } catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
                throw err
            }
        }
    }

    async function getgstdetails() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-gst-details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "organization_id": organization_id, "page_name": page_name }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if (body.operation === "success") {
            setOrgGstinList(body.data)
        }
    }

    async function getEcommerceInvoicePreview() {
        setEcommerceInvoicePreviewApiState(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-ecommerce-invoice-preview`, { method: 'POST', body: JSON.stringify({ "email": user.email, "warehouse_processing_id": selectedWarehouseProcessingId, "org_gstin": selectedGstin, "organization_id": organization_id, "page_name": page_name }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if (body.operation === "success") {
            setInvoiceList(body.data)
            setEcommerceInvoicePreviewApiState(false)
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {
            const controller = new AbortController();
            const signal = controller.signal;

            let p1 = getTimezoneInformation();
            let p2 = getEcommerceWarehouseProcessingList(signal, startDate, endDate, current_page, pageSize, searchValue, statusType.value);
            let p3 = getgstdetails();

            Promise.all([p1, p2, p3])
                .then(() => {
                    setstate(1)
                    console.log("all apis done")
                })
                .catch((err) => {
                    setstate(3)
                    console.log(err)
                })

            return () => {
                controller.abort();
            };
        }
    }, [user, visibility, read, write])

    useEffect(() => {
        if (state == 1) {
            const controller = new AbortController();
            const signal = controller.signal;

            getEcommerceWarehouseProcessingList(signal, startDate, endDate, current_page, pageSize, searchValue, statusType.value)

            return () => {
                controller.abort();
            };
        }
    }, [startDate, endDate, current_page, pageSize, searchValue, statusType.value])

    const newEcommerceInvoiceSubmit = () => {
        var object = {}

        object.warehouse_processing_id = selectedWarehouseProcessingId;
        object.org_gstin = selectedGstin;

        object.organization_id = organization_id;
        object.page_name = page_name;

        // console.log(object);
        setEcommerceInvoiceSubmitApiState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/add-ecommerce-invoice`, object, headers).then((res) => {
            setEcommerceInvoiceSubmitApiState(false)
            if (res.data.operation === "success") {
                swal("Great!", res.data.message, "success").then((value) => { history.push(`/view-ecommerce-order/${ecommerceWarehouseProcessingList.find(x => x.warehouse_processing_id === selectedWarehouseProcessingId).order_id}`) });
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const handleCreateInvoiceModalClose = () => {
        setCreateInvoiceModalShow(false)
        setSelectedWarehouseProcessingId(null)
        setWizardState(0)
        setSelectedGstin(null)
        setInvoiceList([])
    }

    return (
        <>
            <div>
                <div className="d-flex flex-stack">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Ecommerce Warehouse Processing List</h1>
                </div>
                <div>
                    {
                        state === 1 ?
                            <>
                                <div className="row gx-0 gap-5 m-2">
                                    <div className='col-md-3'>
                                        {(startDate !== "" && endDate != "") &&
                                            <div className="d-flex align-items-center gap-5 mx-5 my-2">
                                                <DateRangePickerComponent
                                                    ref={daterange_picker_ref}
                                                    allowEdit={false}
                                                    focus={(e) => {
                                                        daterange_picker_ref.current.show()
                                                    }}
                                                    delayUpdate={true}
                                                    presets={presets}
                                                    change={(e) => {
                                                        setStartDate(moment(e.startDate).format("YYYY-MM-DD"));
                                                        setEndDate(moment(e.endDate).format("YYYY-MM-DD"));
                                                    }}
                                                    startDate={new Date(startDate)}
                                                    endDate={new Date(endDate)}
                                                    max={new Date().toISOString().split('T')[0]}
                                                />
                                            </div>
                                        }
                                    </div>
                                    <div className='col-md-3'>
                                        <Select
                                            options={[{ label: "All", value: "All" }, ...statusTypeArray.map(x => { return { label: x.replace("ECOMMERCE_WAREHOUSE", "").toLowerCase().replace(/_/g, ' ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()), value: x } })]}
                                            onChange={(event) => { setStatusType(event); }}
                                            value={statusType}
                                            placeholder="Select Type..."
                                            styles={theme === 'dark' ? dropdownStyleDark : {}}
                                        />
                                    </div>
                                </div>
                                <div className="card mb-5 mb-xl-8">
                                    <div className="card-body py-3">
                                        <div className='mb-5'>
                                            <input type="text" className='form-control fw-bold border border-primary' value={searchValue} onChange={(e) => { setSearchValue(e.target.value) }} placeholder='Search...' />
                                        </div>
                                        <div className="d-flex flex-column align-items-center" style={{ minHeight: "50vh" }}>
                                            <div className="mb-5 d-flex justify-content-center">
                                                <Pagination
                                                    total={totalListLength}
                                                    onChange={(page, pageSize) => {
                                                        setCurrent_page(page);
                                                        setPageSize(pageSize);
                                                    }}
                                                    showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                                                    defaultPageSize={pageSize}
                                                    defaultCurrent={current_page}
                                                    showSizeChanger={true}
                                                />
                                            </div>
                                            <div className='overflow-auto w-100 flex-grow-1'>
                                                <table className="table table-row-bordered text-nowrap table-row-gray-100 align-middle gs-0 gy-3 h-preserve-whitespace" style={{ minWidth: "1000px" }}>
                                                    <thead>
                                                        <tr className="fw-bold text-muted">
                                                            <th className="min-w-150px">Order Id</th>
                                                            <th className="min-w-120px">Order Number</th>
                                                            <th className="min-w-120px">Items</th>
                                                            <th className="min-w-120px">Added By</th>
                                                            <th className="min-w-140px">Date</th>
                                                            <th className="min-w-120px">Status</th>
                                                            <th className="min-w-50px text-end">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            ecommerceWarehouseProcessingListApiState ?
                                                                <tr>
                                                                    <td colSpan={7} className="text-center pt-10">
                                                                        <div className="spinner-border text-primary"></div>
                                                                    </td>
                                                                </tr>
                                                                :
                                                                ecommerceWarehouseProcessingList.length > 0 ?
                                                                    ecommerceWarehouseProcessingList.map((obj3, indx3) => {
                                                                        return (
                                                                            <tr key={indx3}>
                                                                                <td><a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj3.ref_order_id}</a></td>
                                                                                <td><a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj3.order_number}</a></td>
                                                                                <td><button className="btn btn-sm btn-info fs-8 px-3 py-2 rounded" onClick={() => { setItemDetailsModalShow(true); setItemArrayIndex(indx3) }}>View</button></td>
                                                                                <td><a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj3.user_id}</a></td>
                                                                                <td><a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{moment(obj3.add_date_time).utcOffset(timezone_change).format("ll")}</a></td>
                                                                                <td><StatusBadge status={obj3.add_status} entity={"ECOMMERCE_WAREHOUSE"} /></td>
                                                                                <td className="text-end">
                                                                                    <div className="dropdown">
                                                                                        <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                                                            <i className="fas fa-bars px-0"></i>
                                                                                        </button>
                                                                                        {write &&
                                                                                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                                                {(obj3.add_status == "ECOMMERCE_WAREHOUSE_PROCESSING_INIT" || obj3.add_status == "ECOMMERCE_WAREHOUSE_PROCESSING_PARTIAL") && <li className="py-1"><Link to={`/ecommerce-warehouse-processing/${obj3.warehouse_processing_id}`} className="dropdown-item">Process</Link></li>}
                                                                                                {(obj3.add_status == "ECOMMERCE_WAREHOUSE_PROCESSED" || obj3.add_status == "ECOMMERCE_WAREHOUSE_PROCESSING_PARTIAL") && <li className="py-1"><Link to={`/create-ecommerce-delivery-challan/${obj3.warehouse_processing_id}`} className="dropdown-item">Create Delivery Challan</Link></li>}
                                                                                                {(obj3.add_status == "ECOMMERCE_WAREHOUSE_PROCESSED" && obj3.ecom_order_status === "ECOMMERCE_ORDER_WAREHOUSE") && <li className="py-1 dropdown-item cursor-pointer" onClick={() => { setCreateInvoiceModalShow(true); setSelectedWarehouseProcessingId(obj3.warehouse_processing_id) }}>Create Ecommerce Invoices</li>}
                                                                                                {obj3.add_status !== "ECOMMERCE_WAREHOUSE_PROCESSING_INIT" && <li className="py-1"><Link className="dropdown-item" to={{ pathname: `/view-ecommerce-order/${obj3.order_id}`, state: { activeTab: 'warehouse_processing_summary' } }}>View Details</Link></li>}
                                                                                            </ul>
                                                                                        }
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                    :
                                                                    <tr>
                                                                        <td colSpan={7} className="text-center">
                                                                            <h3 className="text-muted pt-6">No data to be shown</h3>
                                                                        </td>
                                                                    </tr>
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="mt-5 d-flex justify-content-center">
                                                <div className="card-toolbar">
                                                    <Pagination
                                                        total={totalListLength}
                                                        onChange={(page, pageSize) => {
                                                            setCurrent_page(page);
                                                            setPageSize(pageSize);
                                                        }}
                                                        showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                                                        defaultPageSize={pageSize}
                                                        defaultCurrent={current_page}
                                                        showSizeChanger={true}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                            :
                            state === 2 ?
                                <PageLoader />
                                :
                                <PageError />
                    }
                </div>
            </div>

            <Modal show={itemDetailsModalShow} onHide={() => { setItemDetailsModalShow(false); }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Items</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setItemDetailsModalShow(false); }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div className="d-flex border-bottom">
                            <span className="col-8 fw-bold text-primary fs-2 d-block mb-1">Item Name</span>
                            <span className="col-4 text-center fw-bold text-primary fs-2 d-block mb-1">Quantity</span>
                        </div>
                        {
                            itemDetailsModalShow && ecommerceWarehouseProcessingList[itemArrayIndex].item_array.map((obj, indx) => (
                                <div className="d-flex py-3 border-bottom" key={obj.item_id}>
                                    <div className="col-8 d-flex flex-column">
                                        <span className="fs-3">{obj.item_name}</span>
                                        {
                                            obj.item_stock_type !== null &&
                                            <div>
                                                <span className={`badge ${obj.item_stock_type === "Track Serial Number" ? "badge-light-success" : obj.item_stock_type === "Track Batches" ? "badge-light-info" : "badge-light-primary"}`}>{obj.item_stock_type === "Track Serial Number" ? "Serial" : obj.item_stock_type === "Track Batches" ? "Batches" : "Quantity"}</span>
                                            </div>
                                        }
                                    </div>
                                    <span className="col-4 text-center fs-3">{obj.warehouse_list.reduce((acc, curr) => acc + curr.quantity, 0)}</span>
                                </div>
                            ))
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded" onClick={() => { setItemDetailsModalShow(false) }}>Close</button>
                </Modal.Footer>
            </Modal>

            <Modal show={createInvoiceModalShow} onHide={() => { handleCreateInvoiceModalClose(); }} dialogClassName="h-modal-90" centered>
                <Modal.Header>
                    <Modal.Title>{`${wizardState === 0 ? "Select a GSTIN number for creating Invoices" : "Invoices Preview"}`}</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { handleCreateInvoiceModalClose(); }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        {
                            wizardState === 0 ?
                                <div className="row gy-5 justify-content-center">
                                    {
                                        orgGstinList.length ?
                                            orgGstinList.map((obj) => (
                                                <div className="col-4">
                                                    <div key={obj.unique_id} className="position-relative fv-row w-100 flex-md-root cursor-pointer" onClick={() => { setSelectedGstin(obj.unique_id); }}>
                                                        <div className="card h-lg-100 shadow-sm rounded">
                                                            <div className="card-header">
                                                                <div className="card-title flex-column">
                                                                    <h3 className="fw-bolder text-primary">{obj.GstIn}</h3>
                                                                </div>
                                                            </div>
                                                            <div className="card-body p-4 bg-white rounded">
                                                                <div className="border border-dashed rounded py-3 px-4 mx-2 mb-3 bg-light">
                                                                    <div className="fs-6 fw-bold text-gray-700">{obj.legal_name}</div>
                                                                    <div className="fw-semibold text-gray-400">Business Legal Name</div>
                                                                </div>
                                                                <div className="border border-dashed rounded py-3 px-4 mx-2 mb-3 bg-light">
                                                                    <div className="fs-6 fw-bold text-gray-700">{obj.trade_name}</div>
                                                                    <div className="fw-semibold text-gray-400">Trade Name</div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {
                                                            selectedGstin !== null && selectedGstin === obj.unique_id &&
                                                            <div className='position-absolute' style={{ top: "1.5rem", right: "1.5rem" }} >
                                                                <svg width="30" height="30" viewBox="0 0 64 64">
                                                                    <path d="M32,2C15.431,2,2,15.432,2,32c0,16.568,13.432,30,30,30c16.568,0,30-13.432,30-30C62,15.432,48.568,2,32,2z M25.025,50  l-0.02-0.02L24.988,50L11,35.6l7.029-7.164l6.977,7.184l21-21.619L53,21.199L25.025,50z" fill="#43a047" />
                                                                </svg>
                                                            </div>
                                                        }
                                                    </div>

                                                </div>
                                            ))
                                            :
                                            <div className="text-center text-gray-600 fs-3">No Organization GSTINs available</div>
                                    }
                                </div>
                                :
                                <>
                                    {
                                        ecommerceInvoicePreviewApiState ?
                                            <div className="text-center"><div className="spinner spinner-border text-primary" style={{ width: "6rem", height: "6rem" }}></div></div> :
                                            <EcommerceOrderAssociatedInvoices invoiceList={invoiceList} />
                                    }
                                </>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {
                        wizardState === 0 ?
                            <button className="btn btn-primary rounded" disabled={!selectedGstin} onClick={() => { setWizardState(1); getEcommerceInvoicePreview() }}>Show Invoice(s) Preview</button>
                            :
                            <>
                                <button className="btn btn-primary rounded" onClick={() => { setWizardState(0) }}>Previous</button>
                                <button className="btn btn-success rounded" data-kt-indicator={ecommerceInvoicePreviewApiState || ecommerceInvoiceSubmitApiState ? "on" : "off"} disabled={ecommerceInvoicePreviewApiState || ecommerceInvoiceSubmitApiState} onClick={() => { newEcommerceInvoiceSubmit() }}>
                                    <span className="indicator-label">Save Invoice(s)</span>
                                    <span className="indicator-progress">Please wait...
                                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                    </span>
                                </button>
                            </>
                    }
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default EcommerceWarehouseProcessingList;